// Dependencies
import { h, Component } from 'preact';
import {connect} from 'react-redux'

// Components
import WidgetComponent from 'components/WidgetComponent'
import {Form, I18n, Row, Col, Container, Button} from 'components/elements'
import LoadingIcon from 'components/elements/LoadingIcon';

// Actions
import {
    AccountActions, 
    FilterActions, 
    SessionActions,
    PageActions
} from 'actions'
import LoadingActions from "actions/LoadingActions";

// Styles
import style from './style.less'; 


// Class Component
@Form
@connect((state)=> state)
export default class LoginOrSignup extends WidgetComponent { 

    // Constructor
	constructor(){
        super()
        this.state={
            validPhone: false,
            validEmail: false
        }
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.setFilter = this.setFilter.bind(this)
        this.filterSubmitSpinner = this.filterSubmitSpinner.bind(this)
        this.handlePhoneNumberValidation = this.handlePhoneNumberValidation.bind(this)
	}

    // Getters
    get session(){
        return this.props.session || {}
    }

    get validAuthenticator(){
        return this.state.validEmail && this.state.validPhone
    }

    // Methods
    handleEmailChange(e){
        e.preventDefault()
        
        const validEmail = e.target.value.includes('@');
        if(this.state.validEmail !== validEmail){
            this.setState({
                _emailAuthenticator: e.target.value,
                validEmail
            })
        }
    }

    handlePhoneNumberValidation(e){
        e.preventDefault()
        let phoneNumberRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
        
        const validPhone = e.target.value.match(phoneNumberRegex)
        if(this.state.validPhone !== validPhone) {
            this.setState({
                _phoneNumberAuthenticator: e.target.value.replaceAll('-',''),
                validPhone
            })
        }
    }

    handleSubmit(formData){
        LoadingActions.append({LoginOrSignup: true});
        let email = formData.email
        let mobilePhone = formData.mobilePhone
        if(mobilePhone) {
            mobilePhone = mobilePhone.replaceAll('-','')    
        }
        AccountActions.authenticatorCheck({
            email, 
            mobilePhone
        }).then((response)=>{
            if(response.data.email || response.data.mobilePhone){
                SessionActions.setAuthenticationMode('login')
                PageActions.navToLogin()
            } else {
                SessionActions.setAuthenticationMode('signup')
                PageActions.navToFilters()
            }

            this.setFilter({authenticator: email || mobilePhone})
            AccountActions.set({
                email,
                mobilePhone
            })

            super.componentDidSubmit()
        })
        .catch((e)=>{
            console.log(e)
            LoadingActions.append({LoginOrSignup: false});

        })
    }

    setFilter(data){
        FilterActions.set({
            ...this.props.filters,
            ...data
        })
    }   

    filterSubmitSpinner(){
        return this.props.loading.organization || this.props.loading.patientData
    }

    
    // Render Component
	render() {
        const {Form, InputDark, MaskedInputDark} = this.props
        return (
            <Form id='loginOrSignup' onSubmit={this.handleSubmit} class={`${style.loginOrSignup} ${(this.session.resetPassword && style.faded) || ""}`}>
                {this.props.loading.init ? (
                    <div className={style.loadingAnimation}>
                        <LoadingIcon size={100}/>
                    </div>
                ) : (
                    <Container class={`${this.props.class || ""} ${style.containerView || ""}`}>
                        <Row>
                            <Col span={{sm:24}} class={style.noPadding}>          
                                <h3>{I18n.t('enterYourEmail')}</h3>
                                <InputDark 
                                    autoComplete='email'
                                    required={!this.validAuthenticator}
                                    name="email"
                                    id="email" 
                                    key="email"
                                    pattern=".+@.+\..+"
                                    placeholder={I18n.t('loginOrSignEnterEmail')}
                                    onChange={this.handleEmailChange} 
                                    initialValue={this.props.config.prefillEmail}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={{sm:24}} class={style.noPadding}>            
                                <h3>{I18n.t('enterYourPhoneNumber')}</h3>
                                <MaskedInputDark 
                                    autoComplete='tel'
                                    required={!this.validAuthenticator}
                                    name="mobilePhone" 
                                    type="tel"
                                    id="mobile-phone" 
                                    key="mobile-phone"
                                    pattern="[0-9]{3}[\-][0-9]{3}[\-][0-9]{4}" 
                                    placeholder={I18n.t('loginOrSignEnterPhone')}
                                    onChange={this.handlePhoneNumberValidation} 
                                    initialValue={this.props.config.prefillMobilePhone}
                                />
                            </Col>
                        </Row>
                        <Row class={style.thirdItem}>
                            <Col span={{sm:24}}>
                                <div className={style.infoMessage}>
                                    <p>
                                        <span>{I18n.t('enterYourEmail')}</span>
                                        {I18n.t('whyDoWeNeedThisRespond')}
                                    </p>
                                </div>
                            </Col>
                            <Col span={{sm:24}}>
                                <Button type='submit' spinner={this.props.loading.LoginOrSignup}>
                                    {I18n.t('submit')}
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                )}
            </Form>
		);
	}
}



// WEBPACK FOOTER //
// ./components/groups/LoginOrSignup/index.js